<template>
  <BaseView :onMainButtonPressed="null" :onScroll="onScroll">
    <template #header>
      <SearchVoyageComponent />
    </template>

    <template #content>
      <EmptyVoyages v-if="requestFailed" message="Could not fetch routes" />
      <EmptyVoyages v-else-if="noVoyages" message="No routes found" />
      <VoyagesLoading v-else-if="fetchLoading" />
      <VoyagesSuccess v-else />
    </template>
  </BaseView>
</template>
<script>
import { mapState, mapGetters } from "vuex";
import VoyagesSuccess from "./SuccessView.vue";
import VoyagesLoading from "./LoadingView.vue";
import SearchVoyageComponent from "./components/SearchVoyage.vue";
import EmptyVoyages from "./components/EmptyList.vue";
import BaseView from "../../components/BaseView.vue";

export default {
  data: () => ({
    showAction: false,
    enableAction: false,
    dialog: false,
    selectedVoyage: "",
  }),
  components: {
    VoyagesLoading,
    VoyagesSuccess,
    EmptyVoyages,
    BaseView,
    SearchVoyageComponent,
  },
  computed: {
    ...mapState("weatherRouting/voyagesModule", ["fetchLoading", "fetchError"]),
    ...mapGetters("weatherRouting/voyagesModule", [
      "requestFailed",
      "noVoyages",
    ]),
  },
  methods: {
    onScroll(event) {
      if (
        event.target.scrollTop + event.target.clientHeight >=
        event.target.scrollHeight
      ) {
        this.$store.dispatch(
          "weatherRouting/voyagesModule/paginatedFetchAllVoyages"
        );
      }
    },
  },
};
</script>